module.exports = __webpack_public_path__ + "img/禹余粮.f678418c.jpg";